"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IosShare_1 = __importDefault(require("@mui/icons-material/IosShare"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const helpers_1 = require("../../../../common/helpers/helpers");
const InstructionsWrapper = styled_components_1.default.div `
  margin: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  height: calc(100% - 32px);

  .icon-wrapper {
    background-color: #000;
    border-radius: 50%;
    margin-bottom: 20px;
    height: 75px;
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chat-icon {
    color: white;
    width: 50px;
    height: 50px;
  }

  .center-text {
    max-width: 80%;
  }

  .with-image-between {
    p {
      display: inline;
    }

    .share-icon {
      color: rgba(0, 0, 0, 60%);
      position: relative;
      height: 18px;
      top: 1px;
    }
  }

  h5 {
    text-align: center;
  }

  ol {
    padding: 0 0 0 18px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  li {
    width: 100%;
    margin-bottom: 12px;
  }

  .ios-info-section {
    margin-top: 20px;
    display: flex;
    align-items: center;

    .info-icon {
      margin-right: 6px;
      height: 20px;
      width: 20px;
    }
  }
`;
const NotificationInstructionsModal = ({ onClose, appData }) => (react_1.default.createElement(InstructionsWrapper, null,
    react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
            onClose();
        }, sx: {
            position: "absolute",
            right: 8,
            top: 8,
            zIndex: "2",
            backgroundColor: "#fff",
            opacity: "0.75",
        } },
        react_1.default.createElement(Close_1.default, null)),
    react_1.default.createElement("div", { className: "icon-wrapper" },
        react_1.default.createElement(Notifications_1.default, { className: "chat-icon" })),
    react_1.default.createElement(Typography_1.default, { variant: "h5", className: "center-text" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_header")),
    react_1.default.createElement("ol", { type: "1", className: "center-text" },
        react_1.default.createElement("li", null,
            react_1.default.createElement("div", { className: "with-image-between" },
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_body_part1")),
                react_1.default.createElement(IosShare_1.default, { className: "share-icon" }),
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_body_part2")))),
        react_1.default.createElement("li", null,
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_body_part3"))),
        react_1.default.createElement("li", null,
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_body_part4")))),
    react_1.default.createElement(Typography_1.default, { variant: "body2", className: "center-text" }, i18n_js_1.default.t("add_web_app_to_Home_Screen_body_part5")),
    !!helpers_1.Helpers.isMobile.iOS() && (react_1.default.createElement("div", { className: "ios-info-section center-text" },
        react_1.default.createElement(Info_1.default, { className: "info-icon" }),
        react_1.default.createElement(Typography_1.default, { variant: "body2" }, helpers_1.Helpers.isTuiBrand(appData.brandSlug)
            ? i18n_js_1.default.t("TUI_wa_notifications_not_available_in_older_iOS")
            : i18n_js_1.default.t("wa_notifications_not_available_in_older_iOS"))))));
const mapStoreToProps = (store) => ({
    appData: store.getValue("appData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(NotificationInstructionsModal);
